import React__default from 'react';
import { MediaQuery, Tooltip } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { usePrescriptionFormInput } from '../../context/PrescriptionFormInputContext.js';

const PrescriptionFormInputLabelTooltip = ()=>{
    const { idPrefix , name  } = usePrescriptionFormInput();
    const { getLabel  } = useIntl();
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React__default.createElement(Tooltip, {
        id: `${idPrefix}-tooltip`,
        className: "prescription-column__tooltip",
        message: getLabel(`products.glasses.prescription.${name}.tooltip`),
        boundariesElement: isDesktop ? 'window' : 'scrollParent'
    });
};

export { PrescriptionFormInputLabelTooltip };
//# sourceMappingURL=PrescriptionFormInputLabelTooltip.js.map
